// REST-опрос статуса агента. В мок-режиме статус приходит по «WS» (MockVoiceSession),
// поэтому здесь polling включается только для реального бэкенда.

import { agentStatusUrl, authHeaders, config } from '../config'
import type { AgentStatus } from '../types'
import { normalizeStatus } from './protocol'

export async function fetchAgentStatus(signal?: AbortSignal): Promise<AgentStatus> {
  const res = await fetch(agentStatusUrl(), {
    method: 'GET',
    headers: { Accept: 'application/json', ...authHeaders() },
    signal,
  })
  if (!res.ok) throw new Error(`Статус агента: HTTP ${res.status}`)
  const json = await res.json()
  // Бэкенд может вернуть {status:{...}} либо плоский объект — поддержим оба.
  return normalizeStatus((json && (json as { status?: unknown }).status) ?? json)
}

/**
 * Запускает периодический опрос. Возвращает функцию остановки.
 * onUpdate вызывается с новым статусом, onError — при сбое запроса.
 */
export function startAgentStatusPolling(
  onUpdate: (s: AgentStatus) => void,
  onError?: (e: unknown) => void,
): () => void {
  let stopped = false
  let controller: AbortController | null = null
  let timer: number | null = null

  const tick = async () => {
    if (stopped) return
    controller = new AbortController()
    try {
      const status = await fetchAgentStatus(controller.signal)
      if (!stopped) onUpdate(status)
    } catch (e) {
      if (!stopped && (e as Error).name !== 'AbortError') onError?.(e)
    } finally {
      if (!stopped) timer = window.setTimeout(tick, config.agentStatusPollMs)
    }
  }

  tick()

  return () => {
    stopped = true
    controller?.abort()
    if (timer != null) clearTimeout(timer)
  }
}
